import { styled } from '@mui/system';
import { Badge, CircularProgress, IconButton, List, Typography } from '@mui/material';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';

export const StyledBadge = styled(Badge)(() => ({
  '& span': {
    fontSize: 9,
    height: 18,
    width: 18,
    minWidth: 18,
    minHeight: 18,
    backgroundColor: '#f44336',
    color: '#fff'
  }
}));

export const StyledNotificationIcon = styled(NotificationsNoneOutlinedIcon)(() => ({
  color: '#fff',
  width: '1.15em',
  height: '1.15em'
}));

export const DrawerContentCtn = styled('div')(() => ({
  height: '100%'
}));

export const DrawerHeader = styled('div')(() => ({
  position: 'sticky',
  top: 0,
  width: '100%',
  boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  padding: '12px 16px',
  backgroundColor: '#fff',
  zIndex: 1
}));

export const DrawerTitleContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledTitle = styled(Typography)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledCloseBtn = styled(IconButton)(() => ({
  right: -8
}));

export const HeaderActions = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8
}));

export const StyledList = styled(List)(() => ({
  overflowY: 'auto',
  // height: 'calc(100% - 64px)',
  height: 'calc(100% - 102px)',
  '&::-webkit-scrollbar-track': {
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3)',
    borderRadius: 10,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar': {
    width: 8,
    backgroundColor: '#F5F5F5'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 10,
    WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,.3)',
    backgroundColor: '#a0a0a0'
  }
}));

export const EmptyTitle = styled(Typography)(() => ({
  display: 'flex',
  alignItems: 'center',
  textAlign: 'center',
  justifyContent: 'center',
  height: 'calc(100% - 102px)'
}));

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  position: 'absolute',
  bottom: 8,
  left: 0,
  right: 0,
  margin: 'auto',
  color: '#747474',
  width: 30,
  height: 30
}));

export const StyledArrowDown = styled(ArrowDownwardOutlinedIcon)(() => ({
  left: 0,
  right: 0,
  bottom: 8,
  width: 32,
  height: 32,
  margin: 'auto',
  position: 'absolute',
  backgroundColor: '#ffffff',
  border: '1px solid #0d0d0d0d',
  borderRadius: '50%',
  zIndex: 1,
  backgroundClip: 'padding-box',
  color: '#0d0d0d',
  boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
  '&:hover': {
    cursor: 'default'
  }
}));
